import { Injectable } from '@angular/core';

@Injectable()
export class Window {

  height(){
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/injectable/window.ts